import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";

import Form from "../../components/form/Form";
import { login } from "../../services/AuthService";
import HelperFormButtons from "../../components/HelperFormButtons";
import yup from "../../utils/yup";

const Login = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const loginSchema = yup
    .object()
    .shape({
      identifier: yup
        .string("The email or phone number is not valid.")
        .required("The email or phone number is required.")
        .test(
          "identifier-check",
          "The email or phone number is not valid.",
          (value) =>
            RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$").test(
              value
            ) ||
            RegExp(
              "^((\\+[1-9]{1,4}[ -]?)|(\\([0-9]{2,3}\\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$"
            ).test(value)
        ),
      password: yup
        .string("The password is not valid.")
        .required("Please enter your password."),
    })
    .required();

  const formDetails = {
    label: "Log in",
    submitButtonLabel: "Log In",
    steps: [
      {
        name: "identifier",
        label: "E-mail or phone number",
        type: "text",
      },
      {
        name: "password",
        label: "Password",
        type: "text",
        htmlType: "password",
      },
    ],
  };

  const form = useForm({
    resolver: yupResolver(loginSchema),
    mode: "onChange",
  });

  const additionalFormButtons = [
    {
      label: "Forgot password",
      route: "/reset-password",
    },
    {
      label: "Register",
      route: "/register",
    },
  ];

  const handleLogin = (values) => {
    login(form.setError)(values).then((response) => {
      toast.success("You have successfully logged in.");
      window.localStorage.setItem(
        "availabilityTracker",
        JSON.stringify({
          user: response,
          accessTokenExpire: response.access_token_expire,
          refreshTokenExpire: response.refresh_token_expire,
        })
      );

      if (searchParams.has("redirect")) {
        navigate(searchParams.get("redirect"));
      } else {
        navigate("/employments");
      }
    });
  };

  return (
    <div>
      <Form formDetails={formDetails} form={form} onSubmit={handleLogin} />
      <Container className="mt-2">
        <Row>
          <HelperFormButtons formButtons={additionalFormButtons} />
        </Row>
      </Container>
    </div>
  );
};

export default Login;
